// Valeurs du formulaire établissement, partagées entre le dialog (fiche école,
// étape wizard) et les brouillons du wizard de création
export interface EstablishmentFormValues {
  name: string;
  isPrincipal: boolean;
  rne: string;
  codeAcademie: string;
  address: string;
  addressComplement: string;
  latitude: number | null;
  longitude: number | null;
  contractType: 'with_contract' | 'without_contract' | '';
}

export const emptyEstablishmentForm: EstablishmentFormValues = {
  name: '',
  isPrincipal: false,
  rne: '',
  codeAcademie: '',
  address: '',
  addressComplement: '',
  latitude: null,
  longitude: null,
  contractType: '',
};
